import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { ParticipantsEditor, type ParticipantsValue } from './ParticipantsEditor';

export interface CandidateData {
    name: string;
    email: string;
}

export interface CandidateFieldsProps {
    candidate: CandidateData;
    onCandidateChange: (candidate: CandidateData) => void;
    editable?: boolean;
    useParticipantsEditor?: boolean;
}

export function CandidateFields({
    candidate,
    onCandidateChange,
    editable = true,
    useParticipantsEditor = false
}: CandidateFieldsProps) {
    if (useParticipantsEditor) {
        const participantsValue: ParticipantsValue = { candidate };

        return (
            <ParticipantsEditor
                value={participantsValue}
                onChange={(val) => onCandidateChange(val.candidate)}
                candidateEditable={editable}
                showCandidate={true}
            />
        );
    }

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex flex-col gap-2">
                <Label htmlFor="candidate-name">Candidate name</Label>
                <Input
                    id="candidate-name"
                    value={candidate.name}
                    disabled={!editable}
                    onChange={(e) => editable && onCandidateChange({ ...candidate, name: e.target.value })}
                    required={editable}
                />
            </div>
            <div className="flex flex-col gap-2">
                <Label htmlFor="candidate-email">Candidate email</Label>
                <Input
                    id="candidate-email"
                    type="email"
                    value={candidate.email}
                    disabled={!editable}
                    onChange={(e) => editable && onCandidateChange({ ...candidate, email: e.target.value })}
                    required={editable}
                />
            </div>
        </div>
    );
}
